var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "job-listing--item-head" },
    [
      _c(
        "div",
        { staticClass: "job-listing--item-head-line1" },
        [
          _c("div", { staticClass: "name" }, [
            _c("a", { attrs: { href: _vm.editUrl } }, [
              _vm._v(_vm._s(_vm.jobProfile.name))
            ])
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "action orange", attrs: { href: _vm.editUrl } },
            [_c("Icon", { attrs: { icon: "settings" } })],
            1
          ),
          _vm._v(" "),
          _c("Messages", {
            attrs: { "job-profile-list-item": _vm.jobProfileListItem },
            on: {
              close: function($event) {
                return _vm.$emit("closeMessages")
              }
            }
          }),
          _vm._v(" "),
          _c("Appointments", {
            attrs: { "job-profile-list-item": _vm.jobProfileListItem },
            on: {
              closeAppointments: function($event) {
                return _vm.$emit("closeAppointments")
              }
            }
          }),
          _vm._v(" "),
          _c("Favorites", {
            attrs: { "job-profile-list-item": _vm.jobProfileListItem },
            on: {
              load: function($event) {
                return _vm.$emit("loadFavorites")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("ShortInfo", { attrs: { "job-profile": _vm.jobProfile } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }